import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subject, takeUntil } from 'rxjs';

import { EventEmitterService } from '../../services/event-emitter.service';
import { SharedAccountDataService } from '../../services/shared-account-data.service';

const POPUP_DELAY_MS = 25000;

@Component({
  selector: 'bwc-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss'],
})
export class MyProfileComponent implements OnInit, OnDestroy {
  popupClass: boolean;
  showAccountPopup = false;
  mobileNavOpen = false;
  cv$ = this.sharedAccountDataService.cv$;
  private popupTimerId: ReturnType<typeof setTimeout> | null = null;
  private readonly destroy$ = new Subject<void>();

  constructor(
    private _eventEmitter: EventEmitterService,
    private sharedAccountDataService: SharedAccountDataService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.setPopupClass();
    this.loadCv();

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.closeMobileNav());

    this._eventEmitter.dataStr.pipe(takeUntil(this.destroy$)).subscribe((msg) => {
      if (msg === 'createAccountPanelOpened') {
        this.clearPopupTimer();
        this.showAccountPopup = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.clearPopupTimer();
    this.closeMobileNav();
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleMobileNav(): void {
    this.mobileNavOpen ? this.closeMobileNav() : this.openMobileNav();
  }

  closeAccountPopup(): void {
    this.showAccountPopup = false;
  }

  public onCreateAccountClick(): void {
    this.openCreateAccount();
  }

  public onDisabledVacanciesClick(): void {
    this.openCreateAccount();
  }

  private openCreateAccount() {
    this.showAccountPopup = false;
    sessionStorage.setItem('redirectAfterActivation', 'vacancies');
    this.closeMobileNav();
    this.router.navigate(['/profile-check']).then(() => {
      setTimeout(() => {
        this._eventEmitter.sendMessage('saveProfile');
      }, 0);
    });
  }

  setPopupClass() {
    this._eventEmitter.dataClass.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.popupClass = data;
    });
  }

  private loadCv(): void {
    this.sharedAccountDataService.loadCv().subscribe({
      next: (cv) => {
        if (!cv.activated) {
          this.startPopupTimer();
        }
      },
      error: (err) => console.error('Error loading CV:', err),
    });
  }

  private startPopupTimer(): void {
    this.clearPopupTimer();
    this.popupTimerId = setTimeout(() => {
      this.showAccountPopup = true;
    }, POPUP_DELAY_MS);
  }

  closeMobileNav(): void {
    this.mobileNavOpen = false;
    document.body.classList.remove('nav-open');
  }

  private openMobileNav(): void {
    this.mobileNavOpen = true;
    document.body.classList.add('nav-open');
  }

  private clearPopupTimer(): void {
    if (this.popupTimerId !== null) {
      clearTimeout(this.popupTimerId);
      this.popupTimerId = null;
    }
  }
}
